var map = {
	"./add_doctor.svg": 933,
	"./connect_with_oncologist.svg": 934,
	"./consult_with_us.svg": 935,
	"./ebook.svg": 936,
	"./edit_email.svg": 937,
	"./general.svg": 938,
	"./missing_data.svg": 939,
	"./next_appointment.svg": 940,
	"./next_scan.svg": 941,
	"./phone_login.svg": 942,
	"./search_doctor.svg": 943,
	"./see_all_options.svg": 944,
	"./send_to_doctor.svg": 945,
	"./share_with_doctor.svg": 946,
	"./treatment_experience.svg": 947,
	"./user_intent.svg": 948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2036;